import React from 'react';
import PropTypes from 'prop-types';
import objectAssign from 'object-assign';
import SqcPower from 'equipmentComponents/SqcPower';

const SqcCertificateScore = (props) => {

    const {
        label,
        certificate,
        colClass,
        certificateKey,
        certificateProperty,
        style
    } = props;

    if (!certificate) {
        return null;
    }
    let labelComponent = null;

    const mergedStyle = objectAssign({
        padding: '2px'
    }, style);

    if (label) {
        labelComponent = (
            <span>
                <label>
                    {label}</label><br/></span>
        );
    }

    return (
        <div className={colClass} style={mergedStyle}>
            {labelComponent}
            <SqcPower
                score={certificate.getIn([certificateKey, certificateProperty, 'score'])}
                value={certificate.getIn([certificateKey, certificateProperty, 'value'])}/>
        </div>

    );
};

SqcCertificateScore.propTypes = {
    label: PropTypes.string,
    colClass: PropTypes.string,
    certificate: PropTypes.object,
    style: PropTypes.object,
    certificateKey: PropTypes.string,
    certificateProperty: PropTypes.string

};
export default SqcCertificateScore;



// WEBPACK FOOTER //
// ./src/components/equipment/SqcCertificateScore.js